<template>
  <div class="sidebar-wrap">
    <div
      class="sidebar"
      :class="{ 'sidebar-open': open }"
    >
      <ul
        class="sidebar-list"
        @mouseover="open = true"
        @mouseleave="open = false"
      >
        <li>
          <router-link
            class="sidebar-item sidebar-item-online"
            :to="{ name: 'reservations' }"
          >
            MIS RESERVAS
          </router-link>
        </li>
        <li>
          <router-link
            class="sidebar-item sidebar-item-grupales"
            :to="{ name: 'departures' }"
          >
            SALIDAS GRUPALES
          </router-link>
        </li>
        <li>
          <router-link
            class="sidebar-item sidebar-item-preview"
            :to="{ name: 'previews' }"
          >
            AVANCES
          </router-link>
        </li>
        <li>
          <a
            class="sidebar-item sidebar-item-itinerarios"
            href="http://cearaevt.tur.ar/itinerarios"
            target="_blank"
          ><span>VER ITINERARIOS</span></a>
        </li>
      </ul>
      <ul
        class="sidebar-list"
        @mouseover="open = true"
        @mouseleave="open = false"
      >
        <li>
          <span class="sidebar-item sidebar-item-enlaces"><u>ENLACES EXTERNOS</u></span>
        </li>
        <li>
          <a
            class="sidebar-item sidebar-item-pagos"
            href="http://cearaevt.tur.ar/shop/variable/"
            target="_blank"
          ><span>PAGOS ONLINE</span></a>
        </li>
        <li><span class="sidebar-item sidebar-item-aplink">ACCESO APLINK</span></li>
        <li>
          <a
            class="sidebar-item sidebar-item-contacto"
            href="http://cearaevt.tur.ar/contacto"
            target="_blank"
          ><span>CONTACTO</span></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({ open: !true }),

  computed: {
    user () {
      return this.$store.state.user
    }
  }
}
</script>
